/**
 * @file index.js
 * @author Andres Solarte
 * @description Initialize Ambulatory Monitoring View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AmbulatoryMonitoringIGView';

export const mapStateToPropsAmbulatoryMonitoringIGList = mapStateToProps;
export const mapDispatchToPropsAmbulatoryMonitoringIGList = mapDispatchToProps;

export default connect(
  mapStateToPropsAmbulatoryMonitoringIGList,
  mapDispatchToPropsAmbulatoryMonitoringIGList
)(View);
